export enum TestId {
  OE_BUTTON = 'oe-button',
  OE_TEXT = 'oe-text',
  MD_TEXT = 'md-text',
  PC_FEEDBACK_RUBRICS = 'pc-feedback-rubrics',
  PC_FEEDBACK_RUBRICS_LOADER = 'pc-feedback-rubrics-loader',
  PC_PENDING_FEEDBACK_LIST = 'pc-pending-feedback-list',
  PC_PENDING_FEEDBACK_LIST_SELECTED = 'pc-pending-feedback-list-selected',
  PC_PENDING_FEEDBACK_LIST_ITEM = 'pc-pending-feedback-list-item',
  PC_PENDING_FEEDBACK_LIST_ITEM_SELECTED = 'pc-pending-feedback-list-item-selected',
  SELECTED_PC_FEEDBACK_PANEL = 'selected-pc-feedback-panel',
  ERROR_MESSAGE_BOX = 'error-message-box',
  ARROW_DIVIDER_LINE = 'arrow-divider-line',
  CIRCLE_ICON = 'circle-icon',
  TEXT_INPUT_SECURED = 'text-input-secured',
  TEXT_INPUT = 'text-input',
  LINK_TEXT = 'link-text',
}

export enum OrganismTestId {
  USERNAME_INPUT = 'username-input',
  PASSWORD_INPUT = 'password-input',
  SUBMIT = 'login-submit',
}

export enum PageTestId {
  LOGIN = 'login-page',
}
